import React from "react";
import Flatpickr from "react-flatpickr";

const MyFlatPicker = (props) => {
    return(
        <div className="input-group">
            <Flatpickr className="form-control" {...props} />
            <span className="input-group-text">
                <i className="ri-time-line"></i>
            </span>
        </div>
    );
};

export default MyFlatPicker;